import { Device } from '@twilio/voice-sdk';
import {
  store,
  getAgentCapabilityToken,
  getLastCallId,
  initializeDevice,
  deviceReady
} from '../redux';

let device = null;
let call = null;
let isInitializing = false;

export async function initDevice() {
  if (isInitializing) return;
  isInitializing = true;

  try {
    const { agent } = store.getState();
    const token = agent && agent.capabilityToken;

    store.dispatch(initializeDevice());
    device = new Device(token);

    device.on('error', err => {
      console.error('Twilio Device error:', err);
    });

    device.on('registered', () => {
      store.dispatch(deviceReady());
    });

    device.on('unregistered', () => {});

    device.on('connect', connection => {
      call = connection;

      const { tasks } = store.getState();
      const currentTaskId =
        tasks && tasks.currentTask && tasks.currentTask.task && tasks.currentTask.task.taskId;

      if (currentTaskId) {
        store.dispatch(getLastCallId(currentTaskId));
      }
    });

    device.on('tokenWillExpire', async () => {
      const newToken = await store.dispatch(getAgentCapabilityToken());

      await device.updateToken(newToken);
    });

    device.on('disconnect', () => {
      // no connection to Twilio, or Token expired
      store.dispatch(getAgentCapabilityToken());
    });

    await device.register();
  } catch (err) {
    console.error('Failed to initialize/register Twilio Device:', err);
  } finally {
    isInitializing = false;
  }
}

export function disconnect() {
  call.disconnect();
  call = null;
}

export async function startCall(taskId) {
  if (!device) {
    throw new Error('Device not initialized');
  }

  if (call) {
    disconnect();
  }

  try {
    call = await device.connect({ TaskId: taskId });
  } catch (err) {
    console.error('Failed to start outbound call:', err);
  }
}

export function destroyDevice() {
  disconnect();

  if (device) {
    device.destroy();
  }

  device = null;
}

export function muteConnection(isMuted) {
  if (!call) return;

  call.mute(isMuted);
}
